import './Terms.css';

export default function Privacy() {
    return (
        <div className="legalPage">
            <div className="legalContent">
                <h1 className="legalTitle">Privacy Policy</h1>
                <p className="legalUpdated">Last updated: April 2026</p>

                <section className="legalSection">
                    <h2>1. Data Controller</h2>
                    <p>
                        The data controller responsible for your personal data is:
                    </p>
                    <div className="companyInfo">
                        <p><strong>GESTOLA LIMITED</strong></p>
                        <p>Griva Digeni, 84, 1st Floor, Office 102</p>
                        <p>Limassol, 3101, Cyprus</p>
                        <p>Registration Number: HE 433243</p>
                    </div>
                </section>

                <section className="legalSection">
                    <h2>2. Data We Collect</h2>
                    <p>We collect the following types of information:</p>

                    <h3>Account Information</h3>
                    <ul>
                        <li>Email address (when you register or sign in)</li>
                        <li>Authentication data from third-party providers (e.g., Google)</li>
                        <li>Account preferences and settings</li>
                    </ul>

                    <h3>Usage Data</h3>
                    <ul>
                        <li>Images you upload for processing</li>
                        <li>Generated content and associated metadata</li>
                        <li>Service usage patterns and preferences</li>
                        <li>Transaction and credit history</li>
                    </ul>

                    <h3>Technical Data</h3>
                    <ul>
                        <li>IP address and approximate location</li>
                        <li>Browser type and version</li>
                        <li>Device information</li>
                        <li>Cookies and similar tracking technologies</li>
                    </ul>
                </section>

                <section className="legalSection">
                    <h2>3. Purpose of Processing</h2>
                    <p>We process your personal data for the following purposes:</p>
                    <ul>
                        <li><strong>Service Delivery:</strong> To provide our AI image and video generation services</li>
                        <li><strong>Account Management:</strong> To create and manage your user account</li>
                        <li><strong>Payment Processing:</strong> To process credit purchases and transactions</li>
                        <li><strong>Service Improvement:</strong> To analyze usage patterns and improve our services</li>
                        <li><strong>Security:</strong> To detect and prevent fraud, abuse, and security threats</li>
                        <li><strong>Legal Compliance:</strong> To comply with applicable laws and regulations</li>
                        <li><strong>Communication:</strong> To send service-related notifications</li>
                    </ul>
                </section>

                <section className="legalSection">
                    <h2>4. Legal Basis for Processing</h2>
                    <p>Under the General Data Protection Regulation (GDPR), we process your data based on:</p>
                    <ul>
                        <li><strong>Contract Performance:</strong> Processing necessary to provide our services</li>
                        <li><strong>Legitimate Interests:</strong> For service improvement and security</li>
                        <li><strong>Legal Obligation:</strong> When required by law</li>
                        <li><strong>Consent:</strong> Where you have given explicit consent</li>
                    </ul>
                </section>

                <section className="legalSection">
                    <h2>5. Data Retention</h2>
                    <p>We retain your data as follows:</p>
                    <ul>
                        <li><strong>Account Data:</strong> Retained while your account is active and for up to 2 years after deletion request</li>
                        <li><strong>Generated Content:</strong> Stored for 30 days after generation, unless saved to your gallery</li>
                        <li><strong>Transaction Records:</strong> Retained for 7 years for legal and accounting purposes</li>
                        <li><strong>Technical Logs:</strong> Retained for up to 90 days</li>
                    </ul>
                </section>

                <section className="legalSection">
                    <h2>6. Your Rights (GDPR)</h2>
                    <p>As Cyprus is an EU member state, you have the following rights under GDPR:</p>
                    <ul>
                        <li><strong>Right of Access:</strong> Request a copy of your personal data</li>
                        <li><strong>Right to Rectification:</strong> Request correction of inaccurate data</li>
                        <li><strong>Right to Erasure:</strong> Request deletion of your data ("right to be forgotten")</li>
                        <li><strong>Right to Restrict Processing:</strong> Request limitation of data processing</li>
                        <li><strong>Right to Data Portability:</strong> Receive your data in a portable format</li>
                        <li><strong>Right to Object:</strong> Object to processing based on legitimate interests</li>
                        <li><strong>Right to Withdraw Consent:</strong> Withdraw consent at any time</li>
                    </ul>
                    <p>
                        To exercise these rights, please contact us using the information provided below.
                    </p>
                </section>

                <section className="legalSection">
                    <h2>7. Data Sharing</h2>
                    <p>We may share your data with:</p>
                    <ul>
                        <li><strong>Service Providers:</strong> Third parties who assist in providing our services (payment processors, cloud hosting)</li>
                        <li><strong>Legal Authorities:</strong> When required by law or to protect our rights</li>
                    </ul>
                    <p>
                        We do not sell your personal data to third parties.
                    </p>
                </section>

                <section className="legalSection">
                    <h2>8. International Transfers</h2>
                    <p>
                        Your data may be transferred to and processed in countries outside the European Economic Area (EEA).
                        When this occurs, we ensure appropriate safeguards are in place, such as Standard Contractual Clauses
                        approved by the European Commission.
                    </p>
                </section>

                <section className="legalSection">
                    <h2>9. Cookies</h2>
                    <p>
                        We use cookies and similar technologies to enhance your experience. These include:
                    </p>
                    <ul>
                        <li><strong>Essential Cookies:</strong> Required for basic site functionality</li>
                        <li><strong>Authentication Cookies:</strong> To keep you logged in</li>
                        <li><strong>Analytics Cookies:</strong> To understand how you use our services</li>
                    </ul>
                </section>

                <section className="legalSection">
                    <h2>10. Security</h2>
                    <p>
                        We implement appropriate technical and organizational measures to protect your personal data
                        against unauthorized access, alteration, disclosure, or destruction. However, no method of
                        transmission over the Internet is 100% secure.
                    </p>
                </section>

                <section className="legalSection">
                    <h2>11. Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. We will notify you of significant changes
                        by posting the new policy on this page with an updated revision date.
                    </p>
                </section>

                <section className="legalSection">
                    <h2>12. Contact Information</h2>
                    <p>
                        For any questions about this Privacy Policy or to exercise your rights, please contact us at:
                    </p>
                    <div className="companyInfo">
                        <p><strong>GESTOLA LIMITED</strong></p>
                        <p>Griva Digeni, 84, 1st Floor, Office 102</p>
                        <p>Limassol, 3101, Cyprus</p>
                    </div>
                    <p>
                        You also have the right to lodge a complaint with the Commissioner for Personal Data Protection
                        in Cyprus if you believe your data protection rights have been violated.
                    </p>
                </section>
            </div>
        </div>
    );
}
